export default __webpack_public_path__ + "slices/main/assets/public/media/product/engage/engagement-leader-reports@2x.40de6e5e5abee030a695d81184605def.png";